import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from 'core/store/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const Credits = () => {
  const { t } = useTranslate();
  const scopes = useSelector((state) => coreEntities.langs.selectors.getLangScopes(state));
  const [credits, setCredits] = useState('');

  useEffect(() => {
    if (scopes && scopes.length > 0) {
      let privacyScope = scopes.filter((scope) => scope.scope === 'credits');
      if (privacyScope && privacyScope.length > 0) {
        setCredits(privacyScope[0].json);
      }
    }
  }, [scopes]);

  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      <h1 className="sr-only">{t('titles:Credits')}</h1>
      {credits && <PdfViewerFullScreen ariaLabel={t('titles:Credits')} url={credits} />}
    </main>
  );
};

export default Credits;
